export default [
  {
    content: "작업 시 회전체에 작업복이 말려들지 않도록 복장을 단정히 하였는가?",
    isChecked: "",
  },
  {
    content: "선반 주변(발판, 베드 등)에 칩, 공구 등이 정리정돈 되어 있는가?",
    isChecked: "",
  },
  {
    content: "가공물이 긴 경우에는 방진구 및 심압대를 사용토록 하고 있는가?",
    isChecked: "",
  },
  {
    content: "칩비산 방지장치 및 칩브레이커는 부착되어 있는가?",
    isChecked: "",
  },
  {
    content: "비상정지버튼은 쉽게 조작할 수 있도록 잘 보이는 위치에 부착되어 있으며 정상적으로 작동하는가?",
    isChecked: "",
  },
  {
    content: "본체 외함 접지 및 누전차단기에 접속하여 사용하는가?",
    isChecked: "",
  },
  {
    content: "칩제거 작업 시 전용 브러쉬를 사용하는가?",
    isChecked: "",
  },
  {
    content: "가공물은 척에 견고하게 고정되어 있는가?",
    isChecked: "",
  },
  {
    content: "회전이 완전히 멈춘 후 가공물을 제거하는가?",
    isChecked: "",
  },
  {
    content: "작업 시 회전체에 작업복이 말려들지 않도록 소매를 단정히 하였는가?",
    isChecked: "",
  },
  {
    content: "작업장 주변 정리정돈은 되어 있는가?",
    isChecked: "",
  },
  {
    content: "작업자는 보안경, 귀마개 등을 착용하고 작업하는가?",
    isChecked: "",
  },
];
